"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var NavigationService_1 = __importDefault(require("./NavigationService"));
var ProjectCreatedEvent_1 = require("@CommonFrontendBackend/Telemetry/ProjectCreatedEvent");
var Navigation = (function () {
    function Navigation(createUi, AsyncButton, make, templateState, BackButton, $state, modal, environment, projectService, apiBaseUrl, telemetry, Tooltip, pageCreationHelper) {
        var _this = this;
        this.telemetry = telemetry;
        var currentTemplateState;
        var navigationService;
        var createPageButtonTooltip;
        var editButtonTooltip;
        var cloneButtonTooltip;
        this.refresh = function (newTemplateState) {
            if (currentTemplateState && currentTemplateState.projectId === newTemplateState.projectId) {
                return;
            }
            currentTemplateState = (0, lodash_1.cloneDeep)(newTemplateState);
            if (createPageButtonTooltip) {
                createPageButtonTooltip.remove();
            }
            if (cloneButtonTooltip) {
                cloneButtonTooltip.remove();
            }
            if (editButtonTooltip) {
                editButtonTooltip.remove();
            }
            navigationService = make(NavigationService_1.default, {
                templateState: newTemplateState,
            });
            _this._ui.title = navigationService.getTemplateName();
            _this._ui.showEditButton = navigationService.getEditVisibility();
            _this._ui.editButton.state = navigationService.getEditState();
            if (navigationService.getEditState() === "disabled") {
                editButtonTooltip = make(Tooltip, {
                    targetSelector: ".template-navigation__edit-button",
                    options: {
                        position: "bottom",
                        customTheme: "helper-theme",
                        stringContent: "You don't have permissions to edit the template",
                        hideAfter: 0,
                        showOnHover: true,
                    },
                });
            }
            _this._ui.showCloneButton = navigationService.getCloneVisibility();
            _this._ui.cloneButton.state = navigationService.getCloneState();
            _this._ui.createProjectButton.state = navigationService.getCreateProjectState();
            if (navigationService.getCloneState() === "disabled") {
                cloneButtonTooltip = make(Tooltip, {
                    targetSelector: ".template-navigation__clone-button",
                    options: {
                        position: "bottom",
                        customTheme: "helper-theme",
                        stringContent: "Only admins can clone the template",
                        hideAfter: 0,
                        showOnHover: true,
                    },
                });
            }
        };
        var cloneTemplate = function () { return __awaiter(_this, void 0, Promise, function () {
            var createdTemplateId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, navigationService.cloneTemplate()];
                    case 1:
                        createdTemplateId = _a.sent();
                        $state.go("templatesMy", { projectId: createdTemplateId });
                        return [2];
                }
            });
        }); };
        var getEditButton = function () {
            var editTemplate = function () {
                return navigationService.editTemplate();
            };
            return new AsyncButton(editTemplate, "Edit", {
                theme: "secondary",
                size: "small",
            });
        };
        var getCloneButton = function () {
            return new AsyncButton(cloneTemplate, "Clone", {
                theme: "secondary",
                size: "small",
                initialState: "idle",
            });
        };
        var getCreateProjectButton = function () {
            var createPage = function () { return __awaiter(_this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.telemetry.track("Template Gallery - Create Page Clicked", {}, { blockIntercom: true });
                            return [4, pageCreationHelper.createPageFromTemplate({
                                    projectId: currentTemplateState.projectId,
                                    name: navigationService.getTemplateName(),
                                    crmInfo: navigationService.getCrmInfo(),
                                    isAccountTemplate: navigationService.isAccountTemplate(),
                                    isAutoExpiryEnabled: navigationService.isAutoExpiryEnabled(),
                                    isSecurityEnabled: navigationService.isSecurityEnabled(),
                                }, ProjectCreatedEvent_1.ProjectCreationUiOrigin.TemplateGallery)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            return new AsyncButton(createPage, "Create Page", {
                size: "small",
                initialState: "idle",
                skipSuccessState: true,
            });
        };
        var getBackButton = function () {
            if (templateState.suppressBackButton) {
                return;
            }
            return BackButton(function () {
                $state.go("dashboard", { nav: "pages" });
            });
        };
        this._ui = createUi(require("./Navigation.html"), {
            editButton: getEditButton(),
            cloneButton: getCloneButton(),
            createProjectButton: getCreateProjectButton(),
            back: getBackButton(),
        });
        if (templateState.projectId) {
            this.refresh(templateState);
        }
    }
    Object.defineProperty(Navigation.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return Navigation;
}());
exports.default = Navigation;
